var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flix-container"},[(_vm.premium_smaller_x())?_c('paymentInfos'):_vm._e(),(_vm.check_server_msg_date())?_c('serverInfos'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }